'use client';

import NextLink, { type LinkProps } from 'next/link';
import React from 'react';

// Custom `Link` component with `forwardRef`
export const Link = React.forwardRef<
  HTMLAnchorElement,
  LinkProps & React.ComponentPropsWithoutRef<'a'>
>(function Link({ href, children, ...props }, ref) {
  return (
    <NextLink href={href} ref={ref} {...props}>
      {children}
    </NextLink>
  );
});
